import React from "react";
import Input from "./Input";
import TextAreaInput from "./TextAreaInput";
import FileInput from "./FileInput";
import CheckboxGroup from "./CheckboxGroup";
import SelectList from "./SelectList";
import RadioList from "./RadioList";
import DateInput from "./DateInput";
import Checkbox from "./Checkbox";
import HtmlField from "./HtmlField";

const InputTypes = ({customField, type, value, onChange, onCheckboxChange, onUploadChange, errors, terms}) => {

    switch (type) {
        case 'form_text_area':
            return <TextAreaInput {...customField} value={value} onChange={onChange} errors={errors[customField.name]}/>
        case 'form_date_field':
            return <DateInput {...customField} value={value} onChange={onChange} errors={errors[customField.name]}/>
        case 'input_file':
            return <FileInput {...customField} onChange={onChange} onUploadChange={onUploadChange} errors={errors[customField.name]} />
        case 'form_checkbox_group':
            return <CheckboxGroup {...customField} value={value} onChange={onChange} errors={errors[customField.name]} onCheckboxChange={onCheckboxChange}/>
        case 'form_checkbox':
            return <Checkbox {...customField} value={value} onChange={onChange} errors={errors[customField.name]} terms={terms}/>
        case 'form_select_list':
            return <SelectList {...customField} value={value} onChange={onChange} errors={errors[customField.name]}/>
        case 'form_radio_list':
            return <RadioList {...customField} value={value} onChange={onChange} errors={errors[customField.name]}/>
        case 'form_custom_html_field':
            return <HtmlField {...customField} value={value} />
        default:
            return <Input {...customField} value={value} input_type={(type === 'input_number' ? 'number' : 'text')} onChange={onChange} errors={errors[customField.name]}/>
    }
};

export default InputTypes
